import { CardColors } from '../card-colors/card-colors'

type SetComponentColorProps = {
  startedItems: number
  totalItems: number
  unavailableItems: number
}

export function setComponentColor({
  startedItems,
  totalItems,
  unavailableItems,
}: SetComponentColorProps) {
  if (startedItems === 0 && unavailableItems === 0) return CardColors.gray

  if (startedItems === totalItems && unavailableItems === 0)
    return CardColors.green

  return CardColors.yellow
}
